import { User } from "~/common/Store/models/User";
import shouldDisplayMapStyle from "./shouldDisplayMapStyle";
import { LowestPricingProduct } from "./getLowestDisplayPrice";

export interface QuantityDiscount {
  endQuantity?: number;
  isLotDiscount: boolean;
  price: number;
  quantity: number;
  startQuantity: number;
}

export default (
  product: LowestPricingProduct,
  lowestPrice: number,
  user: User,
): [boolean, QuantityDiscount[]] => {
  const { price, startBuy = 1 } = product;

  if (!price.quantityDiscounts || price.quantityDiscounts.length <= 0) {
    return [false, []];
  }

  let discounts: QuantityDiscount[] = [];
  const hasLotDiscounts = price.quantityDiscounts.some(
    (discount) => discount.isLotDiscount,
  );
  if (hasLotDiscounts) {
    if (price.salePrice == lowestPrice) {
      discounts = price.quantityDiscounts
        .sort((a, b) => a.startQuantity - b.startQuantity)
        .reduce<QuantityDiscount[]>((acc, discount) => {
          const qualifiedForDiscount = discount.price < lowestPrice;
          if (qualifiedForDiscount) {
            acc.push(discount as unknown as QuantityDiscount);
          }
          return acc;
        }, []);
    } else {
      discounts = price.quantityDiscounts;
    }
  } else {
    discounts = (price.quantityDiscounts ?? [])
      .sort((a, b) => a.startQuantity - b.startQuantity)
      .reduce<QuantityDiscount[]>((acc, discount) => {
        const qualifiedForDiscount =
          discount.price < lowestPrice &&
          // exclude discounts whose range start or end is less than the minimum quantity
          discount.startQuantity > startBuy;
        if (qualifiedForDiscount) {
          acc.push(discount as unknown as QuantityDiscount);
        }
        return acc;
      }, []);
  }

  const displayMapStyle = shouldDisplayMapStyle(product, user);

  const shouldDisplayQuantityDiscountTable =
    !displayMapStyle && discounts.length > 0;

  return [shouldDisplayQuantityDiscountTable, discounts];
};
